import { Commit as CommitIcon } from "components/icons/generated";
import { Commit, VcsProvider } from "types/generated";
import { getCommitDigitsCount } from "utils/commit";

import MetaInfoListItem from "./Item";

type MetaInfoCommitProps = {
  commit: Commit;
  provider: VcsProvider;
};

const MetaInfoCommit = ({ commit, provider }: MetaInfoCommitProps) => {
  return (
    <MetaInfoListItem
      href={commit.url}
      linkText={commit.hash.slice(0, getCommitDigitsCount(provider))}
      icon={CommitIcon}
      tooltip={`Commit set by ${commit.authorName}`}
      target="_blank"
      type="commit"
    />
  );
};

export default MetaInfoCommit;
